import styled from "styled-components";

export const NotesPanel = styled.div`
    height: 100%;
    min-height: 0;
    display: grid;
    grid-template-rows: auto auto minmax(0, 1fr);
    background: #181b22;
    color: #fff;
    font-family: Manrope, Helvetica, sans-serif;
`;

export const NotesHeader = styled.div`
    padding: 1rem 1rem 0.875rem;
    background: rgba(11, 12, 16, 0.5);
`;

export const NotesHeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
`;

export const NotesCollapseButton = styled.button`
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 0.5rem;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.82);
    cursor: pointer;
    display: grid;
    place-items: center;
    font-size: 1.25rem;
    line-height: 1;

    &:hover {
        background: rgba(255, 255, 255, 0.12);
        color: #fff;
    }

    &:focus-visible {
        outline: 2px solid #5B6EF5;
        outline-offset: 2px;
    }
`;

export const NotesTitle = styled.div`
    color: #fff;
    font-size: 0.9375rem;
    font-weight: 900;
    line-height: 1.3;
`;

export const NotesHint = styled.div`
    margin-top: 0.25rem;
    color: rgba(255, 255, 255, 0.54);
    font-size: 0.6875rem;
    line-height: 1.45;
`;

export const NotesTabs = styled.div`
    min-width: 0;
    padding: 0 0.75rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(11, 12, 16, 0.5);
    display: flex;
    align-items: flex-end;
    gap: 0.125rem;
`;

export const NotesTab = styled.button`
    position: relative;
    min-width: 0;
    min-height: 2.6rem;
    border: 0;
    padding: 0 0.7rem;
    background: transparent;
    color: ${p =>
        p.$active
            ? "#fff"
            : "rgba(255, 255, 255, 0.38)"};
    cursor: ${p =>
        p.disabled
            ? "not-allowed"
            : "pointer"};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.6875rem;
    font-weight: 900;
    white-space: nowrap;
    opacity: ${p => p.disabled ? 0.55 : 1};

    &::after {
        content: "";
        position: absolute;
        left: 0.65rem;
        right: 0.65rem;
        bottom: -1px;
        height: 2px;
        border-radius: 999px;
        background: ${p =>
        p.$active
            ? "linear-gradient(90deg, #0B66E4 0%, #7C3AED 100%)"
            : "transparent"};
    }

    &:focus-visible {
        outline: 2px solid rgba(91, 110, 245, 0.7);
        outline-offset: -2px;
        border-radius: 0.35rem;
    }

    &:disabled {
        pointer-events: none;
    }
`;

export const NotesContent = styled.div`
    min-height: 0;
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
`;

export const NotesList = styled.div`
    min-height: 0;
    overflow-y: auto;
    padding: 0.875rem;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.625rem;

    scrollbar-width: thin;
    scrollbar-color:
        rgba(255, 255, 255, 0.18)
        transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.16);
    }
`;

export const EmptyNotes = styled.div`
    min-height: 8rem;
    padding: 1.25rem;
    border: 1px dashed rgba(255, 255, 255, 0.12);
    border-radius: 0.75rem;
    background: rgba(255, 255, 255, 0.025);
    display: grid;
    place-content: center;
    gap: 0.35rem;
    text-align: center;

    strong {
        color: rgba(255, 255, 255, 0.78);
        font-size: 0.75rem;
        font-weight: 900;
    }

    span {
        max-width: 14rem;
        color: rgba(255, 255, 255, 0.42);
        font-size: 0.6875rem;
        line-height: 1.5;
    }
`;

export const NoteCard = styled.div`
    position: relative;
    width: 100%;
    max-width: min(88%, 22rem);
    align-self: ${p => p.$isMine ? "flex-end" : "flex-start"};
    display: flex;
    flex-direction: column;
    align-items: ${p => p.$isMine ? "flex-end" : "flex-start"};
    gap: 0.25rem;
`;

export const NoteHeader = styled.div`
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: ${p => p.$isMine ? "flex-end" : "flex-start"};
    gap: 0.4rem;
    padding: 0 0.125rem;

    strong {
        min-width: 0;
        overflow: hidden;
        color: rgba(175, 187, 198, 0.95);
        font-size: 0.6875rem;
        font-weight: 600;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const NoteActions = styled.div`
    display: inline-flex;
    gap: 0.25rem;
`;

export const NoteActionButton = styled.button`
    border: 0;
    background: transparent;
    color: rgba(175, 187, 198, 0.95);
    cursor: pointer;
    padding: 0.125rem 0.25rem;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.625rem;
    font-weight: 700;
    text-decoration: underline;
`;

export const NoteDeletePopover = styled.div`
    width: min(15rem, 100%);
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 0.625rem;
    background: #11141b;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.36);
    padding: 0.75rem;
    display: grid;
    gap: 0.625rem;
    z-index: 2;
`;

export const NoteDeleteText = styled.div`
    color: rgba(255, 255, 255, 0.88);
    font-size: 0.6875rem;
    font-weight: 700;
    line-height: 1.4;
`;

export const NoteDeleteActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.375rem;
`;

export const NoteDeleteButton = styled.button`
    min-height: 1.875rem;
    border: 1px solid ${p => p.$danger ? "#F04438" : "rgba(255, 255, 255, 0.16)"};
    border-radius: 0.375rem;
    background: ${p => p.$danger ? "#F04438" : "rgba(255, 255, 255, 0.08)"};
    color: #fff;
    cursor: ${p => p.disabled ? "not-allowed" : "pointer"};
    opacity: ${p => p.disabled ? 0.65 : 1};
    padding: 0 0.625rem;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.625rem;
    font-weight: 800;
`;

export const NoteMeta = styled.span`
    flex: 0 0 auto;
    color: rgba(175, 187, 198, 0.95);
    font-size: 0.6875rem;
    font-weight: 400;

    &::before {
        content: "•";
        margin-right: 0.4rem;
        opacity: 0.7;
    }
`;

export const NoteBody = styled.div`
    width: fit-content;
    max-width: 100%;
    box-sizing: border-box;
    padding: 0.2rem 0.8rem;
    border-radius: ${p => p.$isMine ? "0.625rem 0.625rem 0 0.625rem" : "0.625rem 0.625rem 0.625rem 0"};
    background: ${p => p.$isMine ? "var(--calendar-action-primary-bg, #5B6EF5)" : "#FFFFFF"};
    color: ${p => p.$isMine ? "var(--calendar-action-primary-text, #FFFFFF)" : "#25292E"};
    box-shadow: 0rem 0.0625rem 0.3125rem #0000000D;
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.5;
    text-align: ${p => p.$isMine ? "right" : "left"};
    white-space: pre-wrap;
    word-break: break-word;
`;

export const ComposerRow = styled.form`
    padding: 0.75rem;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(11, 12, 16, 0.68);
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.5rem;
`;

export const ComposerInput = styled.input`
    min-width: 0;
    width: 100%;
    height: 2.6rem;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.13);
    border-radius: 0.625rem;
    outline: none;
    background: #11141b;
    color: #fff;
    padding: 0 0.75rem;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;

    &::placeholder {
        color: rgba(255, 255, 255, 0.34);
    }

    &:hover {
        border-color: rgba(255, 255, 255, 0.2);
    }

    &:focus {
        border-color: #5B6EF5;
        box-shadow: 0 0 0 3px rgba(91, 110, 245, 0.16);
    }
`;

export const SendButton = styled.button`
    width: 2.6rem;
    height: 2.6rem;
    flex: 0 0 auto;
    border: 0;
    border-radius: 0.625rem;
    background: ${p =>
        p.disabled
            ? "rgba(255, 255, 255, 0.07)"
            : "linear-gradient(135deg, #0B66E4 0%, #7C3AED 100%)"};
    color: ${p =>
        p.disabled
            ? "rgba(255, 255, 255, 0.3)"
            : "#fff"};
    cursor: ${p =>
        p.disabled
            ? "not-allowed"
            : "pointer"};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition:
        transform 120ms ease,
        opacity 120ms ease,
        box-shadow 120ms ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 0.4rem 1rem rgba(91, 110, 245, 0.22);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:focus-visible {
        outline: 3px solid rgba(91, 110, 245, 0.34);
        outline-offset: 2px;
    }
`;

export const SendIcon = styled.svg`
    width: 1rem;
    height: 1rem;
    display: block;
`;
